import { Route } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy.component';

const route: Route = {
  path: 'privacy-policy',
  component: PrivacyPolicyComponent
};

export default route;
